import { getAxiosInstance } from '@utils/request';
import { AxiosRequestConfig } from 'axios';

export class APIExport {
  readonly url = '/api/table-export/';

  async save(name: string, params: string, config: AxiosRequestConfig) {
    const response = await getAxiosInstance().get(
      `${this.url}${name}/?${params}`,
      config,
    );

    return response;
  }
}
